import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function TransformationSection() {
  const timeline = [{
    day: 'Día 1-2',
    title: 'Configura tu cuenta',
    desc: 'Lista para vender en 30 minutos'
  }, {
    day: 'Día 3-5',
    title: 'Primeros videos',
    desc: 'Subes 3 videos con scripts probados'
  }, {
    day: 'Día 6-7',
    title: 'Primera venta',
    desc: 'La mayoría vende en la primera semana'
  }, {
    day: 'Semana 2-4',
    title: 'Escala tus ganancias',
    desc: 'Llegas a $500+ MXN diarios'
  }];
  return <section className="section-spacing bg-gradient-premium" data-id="element-529">
      <div className="container-narrow" data-id="element-530">
        <div className="text-center mb-10" data-id="element-531">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-success/10 rounded-full mb-3" data-id="element-532">
            <span className="text-xs font-bold text-accent-success" data-id="element-533">
              Tu transformación
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-deep-cocoa mb-3" data-id="element-534">
            De cero a $500 MXN en 7-14 días
          </h2>
          <p className="text-base text-deep-cocoa/70" data-id="element-535">
            El camino que siguieron 2,347 mujeres mexicanas
          </p>
        </div>

        {/* Timeline */}
        <div className="relative max-w-2xl mx-auto mb-10" data-id="element-536">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gradient-to-b from-cta-primary via-cta-secondary to-champagne-gold hidden sm:block" data-id="element-537"></div>

          <div className="space-y-4" data-id="element-538">
            {timeline.map((step, index) => <div key={index} className="relative flex items-start gap-4 animate-fade-in-up" style={{
            animationDelay: `${index * 150}ms`
          }} data-id="element-539">
                {/* Number */}
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-cta-primary to-cta-secondary rounded-xl flex items-center justify-center text-white font-black text-lg shadow-glow-orange z-10" data-id="element-540">
                  {index + 1}
                </div>

                {/* Content */}
                <div className="flex-1 bg-white rounded-xl p-4 shadow-soft" data-id="element-541">
                  <div className="text-xs font-bold text-cta-primary mb-1" data-id="element-542">
                    {step.day}
                  </div>
                  <h3 className="text-base font-bold text-deep-cocoa mb-1" data-id="element-543">
                    {step.title}
                  </h3>
                  <p className="text-sm text-deep-cocoa/70" data-id="element-544">{step.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Result */}
        <div className="bg-white rounded-2xl p-6 shadow-premium max-w-2xl mx-auto" data-id="element-545">
          <p className="text-center text-base text-deep-cocoa/80 mb-4" data-id="element-546">
            Resultado promedio después de 30 días:
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-547">
            <div className="text-center" data-id="element-548">
              <div className="text-xl font-bold text-deep-cocoa/40 line-through" data-id="element-549">
                $0
              </div>
              <div className="text-xs text-deep-cocoa/60" data-id="element-550">Antes</div>
            </div>
            <ArrowRightIcon className="w-6 h-6 text-cta-primary" data-id="element-551" />
            <div className="text-center" data-id="element-552">
              <div className="text-4xl font-black text-gradient-orange" data-id="element-553">
                $8,400+
              </div>
              <div className="text-xs text-deep-cocoa/60" data-id="element-554">Después</div>
            </div>
          </div>
          <p className="text-xs text-center text-deep-cocoa/50 mt-4 italic" data-id="element-555">
            *Resultados individuales varían según dedicación
          </p>
        </div>
      </div>
    </section>;
}